import React from 'react';
import { useTranslation } from 'react-i18next';

import { useGetEarningById } from '~/hooks/use-get-earning-by-id/useGetEarningById';
import { useEarningsInsightDrawer } from '~/widgets/earnings-insight-drawer/useEarningsInsightDrawer';

import { EarningsDateLabel } from '../../components/earnings-date-label/EarningsDateLabel';
import { EarningsExpectationsTable } from './earnings-expectations-table/EarningsExpectationsTable';
import * as S from './PreviewOverview.styles';
import { TargetPriceSection } from './target-price-section/TargetPriceSection';

export const PreviewOverview = ({
  title,
  activeEntityTag,
}: {
  title: string;
  activeEntityTag: string;
}) => {
  const { t } = useTranslation(['earnings']);
  const { earningsId } = useEarningsInsightDrawer();

  const {
    data: earningsData,
    isFetching,
    isError,
    error,
  } = useGetEarningById(earningsId ?? '');

  if (isFetching) {
    return <S.StyledLoader />;
  }

  if (isError) {
    throw new Error(error?.message);
  }

  return (
    <>
      <S.Title>{title}</S.Title>
      <S.Wrapper>
        {earningsData && (
          <>
            <EarningsDateLabel
              date={earningsData?.reporting_date}
              label={t(
                'earningsInsight.drawer.earningsPreview.earningsReleased'
              )}
            />
            <EarningsExpectationsTable earningsData={earningsData} />
          </>
        )}
        <TargetPriceSection entityTag={activeEntityTag} />
      </S.Wrapper>
    </>
  );
};
